import { ReportApiType } from "./types/apiTypes";
import endPoints from "./endPoints";
import apiClient from "../../apiClient/apiClient";

const reportApi: ReportApiType = {
  exportInvalidEmployeesData: endPoints.report.exportInvalidEmployeesImportData,
  exportCampaigns: endPoints.report.exportCampaigns,
  exportContributions: endPoints.report.exportContributions,
  reportGetContributionsData: (payload) =>
    apiClient.post(endPoints.report.reportGetContributionsData(), payload),
  getCampaigns: () => apiClient.get(endPoints.report.getCampaigns()),
  getReportLookups: (organizationId) =>
    apiClient.get(endPoints.report.getReportLookups(organizationId)),
  getCampaignDesignationsReportData: (payload) =>
    apiClient.post(endPoints.report.getCampaignDesignationsReportData(), payload),
 getCampaignDesignationsReportExport: endPoints.report.getCampaignDesignationsReportExport,
 getCheckContributionReportData: (payload) =>
 apiClient.post(endPoints.report.getCheckContributionReportData(), payload),
exportCheckContributions: endPoints.report.exportCheckContributions,
};

export default reportApi;
